import React, { useContext, useEffect, useRef, useState } from 'react';
import Back from '../../components/Header/Back'
import diamond from '../../assests/images/diamond.svg'
import Edit from '../../assests/images/edit.svg'
import Profile2 from '../../assests/images/profile_2.png'
import in_progress from '../../assests/images/in_progress.svg'
import complted_task from '../../assests/images/complted_task.svg'
import cross from '../../assests/images/cross.svg'
import success2 from '../../assests/images/success2.gif'
import { URl } from "../../utils/Common";
import Loader from '../../assests/images/loader.gif'
import { UserProfile, verifyCode } from "../../utils/Api";
import nodata from '../../assests/images/comment-dollar.svg'
import progress from '../../assests/images/in_progress2.svg'
import invalid from '../../assests/images/invalid.gif'
import complete from '../../assests/images/complted_task_ic.svg'
import M from 'materialize-css';
import { Link, useNavigate } from 'react-router-dom';
import { DataContext } from '../../context/DataContext';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import Footer from '../footer/Footer';
import { Redeem } from '../../utils/Api';
import axios from "axios";
const Profile = () => {
  const tabsRef = useRef(null);
  const modalRef = useRef(null);
  const modalRefSucess = useRef(null);
  const [isClicked, setIsClicked] = useState(false);
  const modalRefFail = useRef(null);
  const [code, setCode] = useState('');
  const { data: user, loading: load, error: Err1, refetch: ref1, androidId } = useContext(DataContext);
  const queryClient = useQueryClient();
  const nav = useNavigate()


  const { mutate } = useMutation({
    mutationFn: async (inputCode) => await verifyCode({ android_id: androidId, verification_code: code }),
    onSuccess: (data) => {
      if (modalRefSucess.current && modalRefFail.current) {
        if (data.status == 0) {
          const instance = M.Modal.init(modalRefFail.current, {
          });
          setCode(null);
          instance.open();
          setIsClicked(false);
        } else {

          const instance = M.Modal.init(modalRefSucess.current, {
          });
          const instance2 = M.Modal.init(modalRef.current, {});
          instance2.close();
          setCode('');
          instance.open();
          ref1(androidId);
          setIsClicked(false);
        }
        // alert('refetched');
      }
    },
    onError: (err) => {
      if (modalRefFail.current) {
        const instance = M.Modal.init(modalRefFail.current, {
        });
        setCode('');
        instance.open();
        setIsClicked(false);
      }
    }
  })

  const codeVerify = () => {
    mutate(code);
  }

  useEffect(() => {
    const elems = document.querySelectorAll('.modal');
    M.Modal.init(elems, {
      opacity: 0.8,
    });
  }, []);

  const Activity = async () => {
    const { data } = await axios.post(`${URl}/useractivity`, { user_id: user ? user.user_id : null });
    return data;
  };

  const { data: activity, isLoading: isLoading1, isError, error: error1, refetch: GameRefech } = useQuery({
    queryKey: ["activity", user?.user_id],
    queryFn: Activity,
    enabled: !!(user?.user_id || user?.user_id == 0),
  });
  const Edit1 = (name, images, email) => {
    const dataToSend = {
      name: name,
      pic: images,
      email: email
    };
    nav("/Edit", {
      state: dataToSend
    });
  }

  const handlePopup = () => {
    if (user.is_verified == 1) {
      window.location.href = 'https://cash.minipay.xyz/browse?url=https://games.gamiflykash.xyz/profile'
    } else {
      if (modalRef.current) {
        const instance = M.Modal.init(modalRef.current, {
          dismissible: false
        });
        instance.open();
      }
    }
  }


  useEffect(() => {
    if (activity && tabsRef.current) {
      const instance = M.Tabs.init(tabsRef.current, {});
      instance.select('test1');
    }
  }, [activity])
  const goToDetails = (contest) => {
    nav(`/Details/${contest}`)
  }
  // const hanleredeem = useMutation({
  //   mutationFn: Redeem,
  //   onSuccess: (data) => {
  //     GameRefech()
  //     if (modalRef.current) {
  //       const instance = M.Modal.init(modalRef.current, {
  //       });
  //       instance.open();
  //     }
  //     queryClient.setQueryData(['Redeem'], data);
  //   },
  // });
  // const redeemdiamonds = (value) => {
  //   hanleredeem.mutate({ user_id: user.user_id, idtoken: user.idtoken, value: value });
  // };
  // console.log(activity.result.in_progress.lenght)
  if (isLoading1 || load) return <div className="body_area22">
    <div className="cointainr loader">
      <img src={Loader}></img>
    </div></div>;
  return (
    <div>
      <Back url={'/'}></Back>
      <div className="body_area22">
        <div className="cointainr">
          {/*Profile section*/}
          {activity && activity.status != 0 && <div className="column_area">
            <div className="profile_top">
              <div className="user_data">
                <img src={!activity.user_image ? Profile2 : activity.user_image} alt="user" className="profile_sq" />
                <div className="user_inf">
                  <p className="ttl_bg">{activity.user_name ? activity.user_name : 'You'}</p>
                  <p className="desc">User ID: @ *****{androidId.slice(-5)}</p>
                </div>
              </div>
              {/* <a onClick={() => user.is_verified == 1 ? Edit1(activity.user_name, !activity.user_image ? Profile2 : activity.user_image, activity.user_email) : ''} className="Edit_btn">
                <img src={Edit} alt="edit" />
                Edit
              </a> */}
            </div>
            <div className="d_flx2 gap">
              <div className="earnings totl_daimn">
                <p>Total Diamonds</p>
                <div className="win_daim btn_tp round">
                  <img src={diamond} alt="diamond" />
                  {activity.diamond_balance ? activity.diamond_balance : 0}
                </div>
              </div>
            </div>
            <p className="play_now brdr_10" onClick={handlePopup}>{
              user.is_verified == '1' ? 'Goto Wallet' : 'Connect GamiflyKash Wallet'
            }</p>
            {/*redeem*/}
            {/* <div className="redeem_section">
              <div className="earnings">
                <p>Redeemable Balance</p>
                <div className="redeem_btn">
                  <p className="win_daim btn_tp brd_none">
                    <img src={diamond} alt="diamond" />{activity.diamond_balance ? activity.diamond_balance : 0}
                  </p>
                  <button className={`${activity.diamond_balance <= 0 ? 'redeem_bt disable' : 'redeem_bt'}`} onClick={() => activity.diamond_balance > 0 ? redeemdiamonds(activity.diamond_balance) : ''}>
                    Redeem Now
                  </button>
                </div>
                <p className="desc">
                  Note: On Redeem the USDT will be transferred to your wallet account
                  within 24 hours.{" "}
                </p>
              </div>
            </div> */}
            <div className="d_flx2">
              <h2 className="main_ttl">
                My<p>Activity</p>
              </h2>
            </div>
            <div className="col s12 pdng0">
              <ul className="tabs" ref={tabsRef}>
                <li className="tab col s4">
                  <a href="#test1">
                    Completed
                  </a>
                </li>
                <li className="tab col s4">
                  <a href="#test2">In Progress</a>
                </li>
              </ul>
            </div>

            <div id="test1" className="col s12">
              {activity.result.is_completed.length !== 0 && (
                <div className="flex_gap top_head">
                  <div className="d_flx2 gap">
                    <p>Sr.</p>
                    <p>Game Name</p>
                  </div>
                  <p>Diamonds</p>
                </div>)}

              {activity && activity.result.is_completed.map((data, index) => {
                return (<div className="Tasks_rem">
                  <div className="taks_item">
                    <div className="d_flex roww">
                      <h1 className="task_count">{index+1}</h1>
                      <div className="d_flex">
                        <h2 className="ttl_sm">{data.title}</h2>
                        <p className="desc">{data.played_on}</p>
                      </div>
                    </div>
                    <div className="win_daim btn_tp">
                      <img src={diamond} alt="diamond" />
                      {data.total_prize}
                    </div>
                  </div>
                </div>
                )
              })
              }
              {activity.result.is_completed.length === 0 && (
                <div className='err_msg msg_sm'>
                  <img src={complete} alt='nodata' className="profile_sq" />
                  <p className="desc12">You have not completed any task yet!</p>
                </div>
              )}
            </div>
            <div id="test2" className="col s12">
              {activity.result.in_progress.length !== 0 && (
                <div className="flex_gap top_head">
                  <div className="d_flx2 gap">
                    <p>Sr.</p>
                    <p>Game Name</p>
                  </div>
                  <p>Status</p>
                </div>)}
              <div className="Tasks_rem">
                {activity && activity.result.in_progress.map((data, index) => {
                  return (
                    <div className="taks_inprogress">
                      <div className="taks_item">
                        <div className="d_flex roww">
                          <h1 className="task_count">{index+1}</h1>
                          <div className="d_flex">
                            <h2 className="ttl_sm">{data.title}</h2>
                          </div>
                        </div>
                        <button className="redeem_bt" onClick={() => goToDetails(data.contest_id)}>Complete to Earn</button>
                      </div>
                      <div className="progress">
                        <div className="determinate" style={{ width: `${data.completion_percent}%` }} />
                      </div>
                      <div className="d_flx2 status_info">
                        <p>
                          Completed: <span>{data.completion_percent}%</span>
                        </p>
                        <p>
                          Remaining Task: <span>{(data.total_tasks - data.completed_tasks)}</span>
                        </p>
                      </div>
                      {/* remaing task Message*/}
                      <p className="remaing_task_msg">
                        You are Just {(data.total_tasks - data.completed_tasks)} Steps away to Earn
                        <span className="complte_stats">$ {(data.total_prize * 0.01).toFixed(2)}</span>
                      </p>
                    </div>
                  )
                })
                }


                {activity.result.in_progress.length === 0 && (
                  <div className='err_msg msg_sm'>
                    <img src={progress} alt='nodata' className="profile_sq" />
                    <p className="desc12">Start playing to check the status of your incomplete task!</p>
                  </div>
                )}
              </div>
            </div>

          </div>}

          <div ref={modalRef} id="modal12" className="modal bottom-sheet">
            <div className="modal-content">
              <div class="d_flx2">
                <h2 class="main_ttl">Verify Your<p>Code</p></h2>
                <a href="#" class="modal-close">
                  <img src={cross} alt="cross" class="flt_50" />
                </a>
              </div>
              <p class="desc">For your security, enter the code from the connected app to verify and proceed.</p>

              {
                !isClicked && (
                  <a href="https://cash.minipay.xyz/browse?url=https://games.gamiflykash.xyz/Instruction/0">
                    <button onClick={() => setIsClicked(true)} class="play_now">
                      Get Code
                    </button>
                  </a>
                )
              }
              <div>
                <div className="input-field col s12">
                  <input
                    placeholder="Enter your code..."
                    id="Email"
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    className="validate input_name"
                    name="Code"
                  />
                </div>
                {
                  code?.trim() == '' ? (<button onClick={codeVerify} type="submit" disabled className={`play_now ${isClicked ? '' : 'completed_btn'}`}>
                    Proceed
                  </button>) : (<button onClick={codeVerify} type="submit" className={`play_now ${isClicked ? '' : 'completed_btn'}`}>
                    Proceed
                  </button>)
                }
                {/* <button onClick={codeVerify} type="submit" className={`play_now ${isClicked ? '' : 'completed_btn'}`}>
                  Proceed
                </button> */}

                {
                  isClicked && (
                    <>
                      <p className='desc center'>Don't have an code?</p>
                      <a href="https://cash.minipay.xyz/browse?url=https://games.gamiflykash.xyz/Instruction/0">
                        <button class="play_now completed_btn">
                          Get Code Again
                        </button>
                      </a>
                    </>
                  )
                }

              </div>
            </div>
          </div>

          <div ref={modalRefSucess} id="modal3" className="modal bottom-sheet modal_text ">
            <div className="d_flx2">
              <h2 className="main_ttl" />
              <a href="#" className="modal-close">
                <img src={cross} alt="cross" className="flt_50" />
              </a>
            </div>
            <div className="d_flex center_align">
              <img src={success2} alt="success" className="gif_colr_chnge" />
              <h2 className="main_ttl">Code Verified Successfully</h2>
              <p className="desc center">
                Your code has been verified. <br></br>You’re all set to continue using the app!
              </p>
              <a href="#" className="play_now completed_btn brdr_10 modal-close">
                Close
              </a>
            </div>
          </div>
          {/*  invalid code   */}
          <div ref={modalRefFail} id="modal3" className="modal bottom-sheet modal_text ">
            <div className="d_flx2">
              <h2 className="main_ttl" />
              <a href="#" className="modal-close">
                <img src={cross} alt="cross" className="flt_50" />
              </a>
            </div>
            <div className="d_flex center_align">
              <img src={invalid} alt="success" className="gif_colr_chnge invalid" />
              <h2 className="main_ttl">Invalid Code Entered</h2>
              <p className="desc center">
                Please double-check the code and enter it again to verify your account.
              </p>
              <a href="#" className="play_now completed_btn brdr_10 modal-close">
                Close
              </a>
            </div>
          </div>
          <Footer></Footer>
        </div>
      </div>


    </div>

  )
}

export default Profile

